import { render, staticRenderFns } from "./annotator.vue?vue&type=template&id=008a6fee&scoped=true"
import script from "./annotator.vue?vue&type=script&lang=js"
export * from "./annotator.vue?vue&type=script&lang=js"
import style0 from "./annotator.vue?vue&type=style&index=0&id=008a6fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008a6fee",
  null
  
)

export default component.exports